import React, { useEffect, useState } from 'react';
import { Column } from '@ant-design/plots';



const ColumnChart = ({ data, xLabel, yLabel, color, xAxisLabel, yAxisLabel }) => {
  const [chartColor, setChartColor] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    if (color === "candidateAge") {
      setChartColor(["#2e84bf"]);
    }
    else if (color === "ageGroups") {
      setChartColor(["#37948e"]);
    }
    else if (color === "Conceptual") {
      setChartColor(["#32669E"]);
    }
    else if (color === "During") {
      setChartColor(["#2193AE"]);
    }
    else if (color === "Post") {
      setChartColor(["#4945A8"]);
    }
    else if (color === "Science") {
      setChartColor(["#2193ae"]);
    }
    else if (color === "participantType") {
      setChartColor(["#3f81af"]);
    }
    else {
      setChartColor(["#3f81af"]);
    }
  };

  const config = {
    data,
    xField: xLabel,
    yField: yLabel,
    scale: {
      x: { padding: 0.5 },
      color: {
        range: chartColor
      },
    },
    axis: {
      x: {
        title: xAxisLabel,
        style: {
          titleFill: 'black',
        },
        labelFormatter: (text) => text.length > 10 ? text.slice(0, 10) + '...' : text, // Ellipsis for long labels
      },
      y: {
        title: yAxisLabel,
        style: {
          titleFill: 'black',
        }
      }
    },
    colorField: "",
    label: {
      text: 'value',
      position: 'inside',
    },
    legend: false, 
    tooltip: {
      items: [
        {
          channel: "y",
          name: 'Number:',
          valueFormatter: (val) => `${val}`,
        },
      ],
    },
    style: {
      maxWidth: 50,
    },
  };
  return <Column {...config} />

  // const config = {
  //   data,
  //   scale: {
  //     color: {
  //       range: chartColor
  //     },
  //   },
  //   xField: xLabel,
  //   yField: yLabel,
  //   style: {
  //     maxWidth: 10
  //   },
  //   colorField: "",
  //   label: {
  //     text: 'value',
  //     position: 'inside',
  //   },
  //   legend: false, 
  //   axis: {
  //     x: {
  //       title: xAxisLabel,
  //       style: {
  //         titleFill: 'black',
  //       },
  //       labelFormatter: (text) => text.length > 10 ? text.slice(0, 10) + '...' : text, // Ellipsis for long labels
  //     },
  //     y: {
  //       title: yAxisLabel,
  //       style: {
  //         titleFill: 'black',
  //       }
  //     }
  //   },
  //   tooltip: {
  //     items: [
  //       // {
  //       //   channel: "color",
  //       //   name:xAxisLabel,
  //       //   valueFormatter: (val) => `${val}`,
  //       // },
  //       {
  //         channel: "y",
  //         name:'Number:',
  //         valueFormatter: (val) => `${val}`,
  //       },
  //      ],
  //    },
  // };
  // return <Column {...config} />

};

export default ColumnChart;